// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { EventBus } from "@mgs/ci2019-common/src/mixins/event_bus/EventBus";
import { ModuleHelperMixin } from "#/common/ModuleHelperMixin";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class SliderItemVideo extends mixins(EventBus, ModuleHelperMixin) {
  public get componentName() {
    const prefix = APP_PREFIX.toLowerCase();

    const camelCasePrefix = prefix.charAt(0).toUpperCase() + prefix.slice(1);

    return camelCasePrefix + "SliderItemVideo";
  }

  public mouseTouchPosition: number | null = null;

  @Prop({ default: true })
  public shouldNotify!: boolean;

  @Prop({ default: false })
  public active!: boolean;

  @Prop()
  public duration!: number;

  @Prop()
  public text!: string;

  @Prop()
  public videoSrc!: string;

  @Prop()
  public videoPoster!: string;

  @Prop({ default: false })
  public lightbox!: boolean;

  public created() {
    if (this.shouldNotify) {
      this.dispatch("Slider", "registerSlide", [
        {
          active: this.active,
          duration: this.duration,
          text: this.text,
          component: this.componentName,
          props: {
            videoSrc: this.videoSrc,
            videoPoster: this.videoPoster,
            text: this.text,
            lightbox: this.lightbox,
          },
        },
      ]);
    }
  }

  public mounted() {}

  public destroyed() {}

  public handleMouseDown(e: MouseEvent) {
    if (!this.lightbox) return;

    this.mouseTouchPosition = e.clientX;
  }

  public handleMouseUp(e: MouseEvent) {
    if (!this.lightbox) return;

    const positionDifference = this.mouseTouchPosition! - e.clientX;

    if (positionDifference < 5 && positionDifference > -5) {
      this.$emit("lightbox", {
        videoSrc: this.videoSrc,
        videoPoster: this.videoPoster,
        title: this.text,
      });
    }
  }
}
